import Mercure from './Mercure';

/**
 * Kept as a wrapper with an `echo` property purely so the components that reach
 * for `this.$root.websocket.echo` did not have to change when Reverb was
 * replaced by FrankenPHP's built-in Mercure hub. There is no Echo, no
 * pusher-js, and no separate websocket container any more — Mercure is served
 * from /.well-known/mercure on the app's own origin.
 */
export default class WebSocket {
  constructor() {
    this.echo = new Mercure();
  }
}
